import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import ButtonCircle from '../../components/Common/ButtonCircle';
import {EditGame} from '../../components/CompanyComponents';
import {openDialog} from '../../slices/dialog';
import {
    resetSelectedGame,
    selectSelectedGame,
    selectSelectedRm,
    storeSelectedFollower,
    storeSelectedGame
} from '../../slices/selected';
import {selectUid} from '../../slices/auth';
import {Collections} from '../../api/collections';
import {deleteFileWithExtension} from '../../api/common';
import {getGameSubmissions} from '../../api/company';
import EditIcon from '@material-ui/icons/Edit';
import AttachmentIcon from '@material-ui/icons/Attachment';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from "moment";
import {useHistory} from 'react-router-dom';
import {downloadFileFromUrl, sanitizeUrl} from '../../helpers/misc';
import {MessageToWinners} from '../../components/Dialog/MessageToWinner';
import Button from '../../components/Common/Button';
import {getFollowersFromIds} from '../../api/other';
import {MessageToFollowers} from '../../components/Dialog/MessageToFollowers';
import JSZip from "jszip";
import saveAs from "file-saver";
import {getFileEntry} from '../../helpers/gameSubmission';
import {ConfirmAction} from '../../components/CommonComponents';
import {deleteGame, notifyGameTarget} from '../../api/game';
import {openAlert} from '../../slices/alert';
import {useTranslation} from 'react-i18next';
import {selectUser} from '../../slices/profile';
import NotificationsIcon from '@material-ui/icons/Notifications';
import {finishFullScreenLoading, startFullScreenLoading} from '../../slices/loading';
import {gameRequests, ROUTES} from '../../db/models/const';

export const CompanyRmGame = () => {
    const game = useSelector(selectSelectedGame);
    const user = useSelector(selectUser)
    const dispatch = useDispatch();
    const uid = useSelector(selectUid);
    const history = useHistory();
    const [submissions, setSubmissions] = useState([]);
    const [followers, setFollowers] = useState([]);
    const title = game?.title || "";
    const description = game?.description || "";
    const [request, setRequest] = useState();
    const task = game?.task || "";
    const target = game?.target || "";
    const attachments = game?.attachments || {};
    const link = sanitizeUrl(game?.link || "");
    const reward = game?.reward || "";
    const {t} = useTranslation();
    const duration = game?.deadline ? moment(game.deadline.seconds * 1000).format("DD-MM-YYYY") : t("company_rm_game_durationDays", {days: game?.durationDays});
    const [rows, setRows] = useState([]);
    const rm = useSelector(selectSelectedRm);
    const [selectedFollowers, setSelectedFollowers] = useState([]);
    const onEditClick = () => {
        dispatch(openDialog({
            Content: EditGame,
            title: t("company_rm_editGame_title"),
            props: {game},
            closable: true
        }));
    };

    useEffect(() => {
        if (!game) {
            history.push(ROUTES.ME);
            return;
        }
        const request = gameRequests.find(request => request.id === game.request);
        setRequest(t(request?.label));

        getGameSubmissions(game.id).then(subs => {
            setSubmissions(subs);

            const studentIds = subs.map(sub => sub.studentId);

            getFollowersFromIds(studentIds).then(followers => {
                setFollowers(followers);

                setRows(followers.map(f => {
                    return {
                        name: f?.user?.name,
                        // percentage: affinityPercentage(f?.cv, rm),
                        games: (f?.user?.games || []).filter(g => g.rmId === rm.id).length,
                        wins: (f?.user?.wins || []).filter(w => w.rmId === rm.id).length,
                        winner: (game?.winners || []).includes(f?.user?.id),
                        follower: f
                    }
                }));
            });
        });
    }, [game])

    const onAttachmentDeleteClick = async id => {
        await deleteFileWithExtension(`${uid}/games/${game.id}/attachments/${id}`, ["attachments", id], `${Collections.GAMES}/${game.id}`);
        const atts = {...attachments};
        delete atts[id];
        const updatedGame = {
            ...game,
            attachments: atts
        }
        dispatch(storeSelectedGame({game: updatedGame}))

        // const temp = attachments;
        // delete temp[id];
        // setAttachments(temp);
    }

    const onFollowerClick = async follower => {
        if (!follower) return;

        dispatch(storeSelectedFollower({follower}));
        history.push(ROUTES.FOLLOWER);
    }

    const onWinners = (e) => {
        e.stopPropagation();
        if (selectedFollowers.length === 0) return;

        dispatch(openDialog({
            Content: MessageToWinners,
            title: t("company_rm_setGameWinner_title"),
            props: {
                winners: selectedFollowers,
                game
            },
            closable: true
        }))
    }

    const addChecked = (event, follower) => {
        event.stopPropagation();
        if (selectedFollowers.includes(follower))
            setSelectedFollowers([...selectedFollowers.filter(f => f.user.id !== follower.user.id)]);
        else
            setSelectedFollowers([...selectedFollowers, follower])
    }

    const onMessage = () => {
        if (selectedFollowers.length === 0) return;
        dispatch(openDialog({
            Content: MessageToFollowers,
            title: "Invia un messaggio",
            props: {
                emails: selectedFollowers.map(f => f.info.email)
            },
            closable: true
        }))
    }

    const onDownloadSubmissions = () => {
        const jszip = new JSZip();

        submissions.forEach(sub => {
            const follower = followers.find(f => f.user.id === sub.studentId);
            if (!follower) return;

            //ricava nome e id dello studente
            const studentName = follower?.user?.name;
            const studentId = follower?.user?.id;
            if (!studentId || !studentName) return;

            // ricava nome e url del file caricato durante la submission
            // ricava l'estensione del file
            const {key: fileName, value: url} = getFileEntry(sub);

            if (!fileName || !url) return;

            const fileExt = fileName.split(".")?.[1];

            // genera il nome del file nello zip unendo nome e id studente e l'estensione de file
            const zipFileName = `${studentName}_${studentId.slice(0, 5)}.${fileExt}`;

            jszip.file(
                zipFileName,
                downloadFileFromUrl(url)
            );
        });

        const zipName = game.title.split(' ').join('_');

        jszip.generateAsync({type: "blob"}).then(content => {
            saveAs(content, `${zipName}.zip`);
        });
    }

    const onDeleteClick = gameId => {
        if (!gameId) return;

        const action = () => {
            deleteGame(gameId).then(() => {
                dispatch(openAlert({type: "info", message: t("alert_game_deleted")}));
                history.push("/rm/games");
                dispatch(resetSelectedGame());
            }).catch((error) => {
                console.error(error)
                dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
            })
        }

        dispatch(openDialog({
            Content: ConfirmAction,
            title: "Stai per cancellare il Game",
            props: {
                action
            },
            closable: true
        }))
    }

    return (
        <div className="companyRmGame">
            <div className="card game">
                <div className="card__header border">
                    <div className="card__header__top">
                        <h2>{title}</h2>
                        <div className="actions">
                            <ButtonCircle onClick={() => onEditClick(game)}><EditIcon/></ButtonCircle>
                            <ButtonCircle onClick={() => onDeleteClick(game.id)}><DeleteIcon/></ButtonCircle>
                        </div>
                    </div>
                    {game?.notifiedAt?.seconds !== 0 &&
                        <p className="companyRmGame__notificationDate">{t("company_rm_games_notifiedAt") + moment(game?.notifiedAt?.seconds * 1000).format("DD-MM-YYYY")}</p>}
                </div>
                <div className="card__content">
                    {target && rm?.groups[target]?.name && <div className="item">
                        <label>{t("company_rm_game_target_label")}</label>
                        <p>{rm?.groups[target].name}</p>
                    </div>}
                    <div className="item">
                        <label>{t("company_rm_game_request_label")}</label>
                        <p>{request}</p>
                    </div>
                    <div className="item">
                        <label>{t("company_rm_game_duration_label")}</label>
                        <p>{duration}</p>
                    </div>
                    <div className="item">
                        <label>{t("company_rm_game_desc_label")}</label>
                        <p>{description}</p>
                    </div>

                    <div className="item">
                        <label>{t("company_rm_game_task_label")}</label>
                        <p>{task}</p>
                    </div>
                    <div className="item">
                        <label>{t("company_rm_game_reward_label")}</label>
                        <p>{reward}</p>
                    </div>
                    <div className="item">
                        <label>{t("company_rm_game_link_label")}</label>
                        <a className="link" target="_blank" rel="noopener noreferrer" href={link}>{link}</a>
                    </div>
                    <div className="item">
                        <label>{t("company_rm_game_attachments_label")}</label>
                        <div className="attachments">
                            {Object.entries(attachments).map(e => (
                                <div className="a">
                                    <AttachmentIcon/>
                                    <p key={e[0]}>{t("company_rm_game_att")}{e[0]}</p>
                                    <ButtonCircle
                                        onClick={() => onAttachmentDeleteClick(e[0])}><DeleteIcon/></ButtonCircle>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="bar">
                <h2>{t("company_rm_game_table_title")}</h2>
                <div className="actions">
                    <Button disabled={submissions === 0}
                            onClick={() => onDownloadSubmissions()}>{t("company_rm_game_table_downloadSubBtn")}</Button>
                    <Button disabled={selectedFollowers.length === 0}
                            onClick={(e) => onWinners(e)}>{t("company_rm_game_table_setWinnerBtn")}</Button>
                    <Button disabled={selectedFollowers.length === 0}
                            onClick={() => onMessage()}>{t("company_rm_game_table_sendMsgBtn")}</Button>
                </div>
            </div>
            <div className="card submissions table">
                <table>
                    <thead>
                    <tr>
                        <th>{t("company_rm_game_table_selectHeader")}</th>
                        <th>{t("company_rm_game_table_nameHeader")}</th>
                        {/* <th>Progresso</th> */}
                        <th>{t("company_rm_game_table_gameHeader")}</th>
                        <th>{t("company_rm_game_table_winsHeader")}</th>
                        <th>{t("company_rm_game_table_winnerHeader")}</th>
                    </tr>
                    </thead>
                    {rows.map((row, i) =>
                        <tbody>
                        <tr onClick={() => onFollowerClick(row.follower)}>
                            <td><input type="checkbox" onClick={(e) => addChecked(e, row.follower)}/></td>
                            <td>{row.name}</td>
                            {/* <td>{rows[i]?.percentage}</td> */}
                            <td>{row.games}</td>
                            <td>{row.wins}</td>
                            <td>{row.winner ? "Vincitore" : ""}</td>
                        </tr>
                        </tbody>
                    )}
                </table>
                {/* <ButtonCircle onClick={() => setLoadMore(!loadMore)}><KeyboardArrowRightIcon /></ButtonCircle> */}
                {/* <div className="submission">
                            {submissions.map(sub =>
                                <div className="submission card card--clickable" onClick={() => onFollowerClick(sub)}>
                                    {sub.studentId === game?.winner?.studentId && <div className="win"><EmojiEventsIcon /></div>}
                                    <div className="avatar"
                                        style={{
                                            backgroundImage: `url(${sub?.studentPhotoUrl})` || null,
                                        }}
                                    >
                                    </div>
                                    <label>{sub?.studentName || "Nome"}</label>
                                    <div className="chips">
                                        {Object.entries(sub?.files || {}).map(file => (
                                            <div className="chip">
                                                <p key={file[0]} onClick={(e) => onFileClick(e, file[1])}>File {file[0]}</p>
                                            </div>
                                        ))}
                                    </div>
                                    {isExpired(game.deadline) && !game?.winner &&
                                        <Button onClick={(e) => onWinner(e, sub)}>Setta vincitore</Button>}
                                </div>
                            )}
                        </div> */}
            </div>
        </div>
    )
}
